import { cx } from '@emotion/css';
import styles from '../navigation.module.scss';
import { AppSwitcher } from './app-switcher';
import { useTranslation } from 'next-i18next';
import { useState, useRef } from 'react';
import { useOutsideClick } from '../hooks/useOutsideClick';
import { getDesignSystemIconWithFallback } from '../helpers/utils';

export const AppSwitcherSection = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const outsideClick = useOutsideClick(() => setIsOpen(false));
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <div className={cx('relative ml-8 mr-4 cursor-pointer stihl-text-body-xs-reg', styles.metaNavItem)} ref={outsideClick}>
      <button
        ref={buttonRef}
        type="button"
        className="flex flex-col items-center gap-y-1 focus-visible:outline-offset-[6px] focus-visible:outline-[#252525] focus-visible:outline-[2px] focus-visible:outline border-none"
        data-testid="navigation_app_switcher_button"
        onClick={() => setIsOpen((o) => !o)}
        id="app-switcher-button"
        aria-expanded={isOpen}
        aria-controls="app-switcher-menu"
        aria-haspopup="true"
      >
        <img src={getDesignSystemIconWithFallback('icon-squares-grid.svg')} alt="" className="h-4 w-4 fill-current" />
        <span>{t('shared:topBar_meta_apps_label')}</span>
      </button>
      <AppSwitcher isOpen={isOpen} onClose={() => setIsOpen(false)} triggerRef={buttonRef} />
    </div>
  );
};
